module.exports = __webpack_public_path__ + "static/lightning-datepicker-range-selected-e3040dd7580c37474edc7adc2f3f1041.png";